module.exports = __webpack_public_path__ + "static/media/11_minutos.a1173992.jpg";